import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {PlainTimeFormat, TemporalFormatering} from "../tjenester/TemporalFormatering";
import {PlainTimeSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {lesPlainTimeSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import PlainTime = Temporal.PlainTime;

/**
 * Formaterer PlainTime instanser.
 * Format kan angis som argument nr 2, 'short' gir hh:mm, 'medium' gir hh:mm:ss.
 * 'long' og 'full' skriver ut tidssoneinformasjon, og bør normalt ikke brukes da PlainTime ikke har noen forhold til tidssone.
 *
 * Ved behov for tidssoneinfo bør denne pipen utvides til å ta inne et ekstra argument med tidssone som propageres via options.timeZone */
@Pipe({name: 'plaintime', pure: true, standalone: true})
export class FormaterPlainTimePipe implements PipeTransform {

    constructor(private formatering: TemporalFormatering) {
    }

    transform(klokkeslett: PlainTime | PlainTimeSerialisert | null, format: PlainTimeFormat = 'short'): string | null {
        return this.formatering.formaterPlainTime(
          (klokkeslett instanceof PlainTime) ? klokkeslett : lesPlainTimeSerialisertOpt(klokkeslett),
          format);
    }
}
